import script from "./BudgetJustificationView.vue?vue&type=script&setup=true&lang=js"
export * from "./BudgetJustificationView.vue?vue&type=script&setup=true&lang=js"

import "./BudgetJustificationView.vue?vue&type=style&index=0&id=212d0c3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-212d0c3e"]])

export default __exports__